import { mapDateToObject } from "./GlobalMapper";

export function mapProcessesToDisplay(array) {
  return array.map((item) => ({
    Name: item.name,
    Tenant: item.tenantName,
    Version: item.processVersion,
    Priority: item.jobPriority,
    Description: item.description,
    Framework: item.targetFramework,
    CreationTime: mapDateToObject(item.creationTime),
    organizationUnitId: item.organizationUnitId,
    ProcesKey: item.key,
    RequiresUserInteraction: item.requiresUserInteraction
  }));
}